//import update from 'immutability-helper';

const emptyState = {
  data: null
}

const StatsReducer = (state = emptyState, action) => {
  switch (action.type) {
    case "STATS_INIT": {
      let newData = JSON.parse(JSON.stringify(action.payload));
      return {...state, data: newData};
    }
    default: {
      return state
    }
  }
}

export default StatsReducer